export default __webpack_public_path__ + "static/media/16.c3cb98df.jpg";